module.exports = {
  ...require("./base.json"),
  validation: require("./validation.json"),
  profile: require("./profile.json"),
  reset: require("./reset.json"),
};
